import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  className?: string;
  onClick?: () => void;
  href?: string;
}
export function CTAButton({
  text = '¡SÍ, QUIERO ACTIVAR MI PROSPECCIÓN MAGNÉTICA AHORA!',
  className = '',
  onClick,
  href
}: CTAButtonProps) {
  const handleClick = () => {
    if (href) {
      if (typeof (window as any).fbq === 'function') {
        ;
        (window as any).fbq('track', 'AddToCart');
      }
      window.open(href, '_blank');
    } else if (onClick) {
      onClick();
    } else {
      const el = document.getElementById('pricing-section');
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`group relative flex w-full sm:w-auto items-center justify-center gap-3 rounded-lg bg-brand-gold px-8 py-5 text-center font-heading text-lg font-bold text-brand-darker shadow-[0_0_20px_rgba(212,168,67,0.3)] transition-all hover:bg-brand-goldHover hover:shadow-[0_0_30px_rgba(212,168,67,0.5)] ${className}`} data-id="element-34">
      <span data-id="element-35">{text}</span>
      <ArrowRight className="h-6 w-6 transition-transform group-hover:translate-x-1" data-id="element-36" />
    </motion.button>;
}